export const primaryColor = "#08d8de";
export const secondaryColor = "#0f0f0f";
export const textWithWhiteBg = "#0f0f0f";
export const textWithPrimaryColorBg = "#0f0f0f";
export const linearGradient =
  "linear-gradient(108deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 36.65%, rgba(8, 216, 222, 0.60) 78.17%, rgba(8, 216, 222, 0.60) 124.19%)";
